import { useMutation } from '@apollo/client/react';
import { Alert, Button, Form, Input, Row, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { LoginLogo } from '../../assets/svg/login';
import { GA_EVENT, GA_LABEL, ROUTES } from '../../common/constants';
import { Event } from '../../common/trackEvents';
import useRouter from '../../common/useRouter';
import { formValidatorRules } from '../../common/utils';
import { FORGOT_PASSWORD } from './graphql/Mutations';

const { required, email } = formValidatorRules;

const ForgotPassword = () => {
  const { navigate, location } = useRouter();
  const [form] = Form.useForm();

  const [errorMessage, setErrorMessage] = useState();

  useEffect(() => {
    if (location?.state?.email) {
      form.setFieldsValue({ email: location?.state?.email });
    }
  }, [location?.state]);

  const [forgotPassword, { loading }] = useMutation(FORGOT_PASSWORD, {
    onError(error) {
      setErrorMessage(error?.message);
    },
    onCompleted() {
      Event(GA_EVENT.FORGOT_PASSWORD, {
        label: GA_LABEL.FORGOT_PASSWORD,
        // eslint-disable-next-line no-undef
        pathname: window?.location?.href,
      });
      navigate(ROUTES.LOGIN);
    },
  });

  const onFinish = async (values) => {
    forgotPassword({
      variables: values,
    });
  };

  return (
    <div id="forgot-password-container" className="gx-login-container">
      <div
        id="forgot-password-logo"
        className="login-logo pointer"
        onClick={() => {
          navigate(ROUTES.LOGIN);
        }}
      >
        <LoginLogo width="200" height="60" />
      </div>
      {errorMessage && (
        <Alert
          title={<h3>There was a problem</h3>}
          description={errorMessage}
          type="error"
          showIcon
        />
      )}
      <div className="gx-login-content">
        <div className="card-body">
          <h1>Password assistance</h1>
          <p>Enter the email associated with your Digiqc account</p>
        </div>
        <Spin spinning={false}>
          <Form
            layout="vertical"
            onFinish={onFinish}
            className="gx-login-form gx-form-row0"
            form={form}
          >
            <Form.Item
              name="email"
              label="Email Address"
              rules={[required, email]}
            >
              <Input
                id="forgot-password-email-input"
                autoFocus
                onKeyDown={(e) => {
                  if (e?.code === 'Space') {
                    e?.preventDefault();
                  }
                }}
              />
            </Form.Item>
            <Row className="login-row">
              <Form.Item className="width-percent-100 mt-20">
                <Button
                  id="forgot-password-continue-button"
                  type="primary"
                  htmlType="submit"
                  shape="round"
                  loading={loading}
                >
                  Continue
                </Button>
              </Form.Item>
            </Row>
          </Form>
        </Spin>
      </div>
    </div>
  );
};

export default ForgotPassword;
